import { useParams } from "react-router-dom";
import { isTaskAddPhoto } from "tm-shared/utils";

import { usePointSelector, useTaskSelector } from "@/hooks/redux";
import NotFound from "@/pages/System/NotFound";

import { AddPhotoPage } from "./AddPhotoPage";

const AddPhoto = () => {
    const { pointId = "", taskId = "" } = useParams();

    const currentTask = useTaskSelector(pointId, taskId);
    const currentPoint = usePointSelector(pointId);

    if (!currentTask || !isTaskAddPhoto(currentTask) || !currentPoint)
        return <NotFound />;

    return <AddPhotoPage point={currentPoint} task={currentTask} />;
};

export default AddPhoto;
